import React, { useState } from 'react';
import { Button, useTranslate } from 'react-admin';
import { useParams } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import { PumpsSpeedExportDialog } from './PumpsSpeedExportDialog';

export const PumpsSpeedExportButton = () => {
  const [open, setOpen] = useState(false);
  const params = useParams();
  const t = useTranslate();

  if (!params.pumpId) return null;

  return (
    <>
      <Button
        className="button-primary"
        label={t('resources.pumps.speeds.fields.export')}
        onClick={() => setOpen(true)}
      >
        <DownloadIcon />
      </Button>
      <PumpsSpeedExportDialog
        pumpId={params.pumpId}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
